import { network } from 'services/network';

export const imageComponentUploadImage = (params) => {
    const formData = new FormData();

    if (params.widgetId != null && params.widgetId !== '') {
        formData.append('widgetId', String(params.widgetId));
    }

    if (params.file != null && typeof params.file.size !== 'undefined') {
        formData.append('file', params.file, params.file.name);
    } else if (params.file === null) {
        formData.append('file', null);
    }

    return network
        .post('api/bo/reporting/imageComponentUploadImage', formData, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then((response) => {
            return response.data;
        });
};
